import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { RestConnectorService } from 'app/core/connector-services/rest-connector-service/rest-connector-service.abstract';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FilterInterface, FilterItemInterface, SiteFilterInterface } from '../models';

@Injectable()
export class SiteFilterRestConnectorService extends RestConnectorService {

  constructor(private readonly _httpClient: HttpClient,
              protected readonly _store: Store<AppStateInterface>) {
    super(_store);
  }

  public loadFilter(): Observable<SiteFilterInterface> {

    return this._httpClient.get<SiteFilterInterface>(
        '/api/data-filter',
        { observe: 'response' },
    ).pipe(
        map((httpResponse: HttpResponse<SiteFilterInterface>) => httpResponse.body),
    );
  }

  public updateFilter(siteFilter: SiteFilterInterface): Observable<SiteFilterInterface> {

    return this._httpClient.put<SiteFilterInterface>(
        '/api/data-filter',
        siteFilter,
        { observe: 'response' },
    ).pipe(
        map((httpResponse: HttpResponse<SiteFilterInterface>) => httpResponse.body),
    );
  }

  public getManagementFilters(): Observable<FilterInterface[]> {
    return this._httpClient.get<FilterInterface[]>(
      '/api/data-filter/management',
      { observe: 'response' },
    ).pipe(
        map((httpResponse: HttpResponse<FilterInterface[]>) => httpResponse.body),
    );
  }

  public updateManagmentFilterCategory(itemToUpdate: FilterInterface): Observable<FilterInterface> {
    return this._httpClient.put<FilterInterface>(
      '/api/data-filter/management',
      itemToUpdate,
      { observe: 'response' },
    ).pipe(
        map((httpResponse: HttpResponse<FilterInterface>) => httpResponse.body),
    );
  }

  public createManagementFilterItem(filterId: number, itemToCreate: FilterItemInterface):
  Observable<{ filterId: number, filterItem: FilterItemInterface }> {
    return this._httpClient.post<FilterItemInterface>(
      `/api/data-filter/management/${filterId}`,
      itemToCreate,
      { observe: 'response' },
    ).pipe(
        map((httpResponse: HttpResponse<FilterItemInterface>) => {
          return {
            filterId,
            filterItem: httpResponse.body,
          };
        }),
    );
  }

  public updateManagementFilterItem(filterId: number, itemToUpdate: FilterItemInterface):
  Observable<{ filterId: number, filterItem: FilterItemInterface }> {
    return this._httpClient.put<FilterItemInterface>(
      `/api/data-filter/management/${filterId}`,
      itemToUpdate,
      { observe: 'response' },
    ).pipe(
        map((httpResponse: HttpResponse<FilterItemInterface>) => {
          return {
            filterId,
            filterItem: httpResponse.body,
          };
        }),
    );
  }

  public deleteManagementFilterItem(filterId: number, itemToDelete: FilterItemInterface):
  Observable<{ filterId: number, filterItem: FilterItemInterface }> {
    return this._httpClient.delete(
      `/api/data-filter/management/${filterId}/${itemToDelete.id}`,
      { observe: 'response' },
    ).pipe(
      map((httpResponse: HttpResponse<FilterItemInterface>) => {
        if (httpResponse.status !== 204) {
          return {
            filterId,
            filterItem: httpResponse.body,
          };
        }
        return {
          filterId,
          filterItem: itemToDelete,
        };
      }),
    );
  }
}
